
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-piano-black">
              Mød Oscar Gilbert, <span className="text-piano-gold">din personlige klaverunderviser</span>
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Med en baggrund fra Rytmisk Musikkonservatorium og mange års erfaring som både udøvende pianist og underviser, 
              har Oscar hjulpet hundreder af elever med at opnå deres musikalske mål.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              Oscars pædagogiske tilgang kombinerer teknisk perfektion med musikalsk udtryk, så hver elev 
              udvikler deres eget unikke forhold til klaveret.
            </p>
            <Button asChild className="bg-piano-black hover:bg-piano-black/90 text-white">
              <Link to="/om">Læs Mere Om Oscar</Link>
            </Button>
          </div>
          <div className="order-1 lg:order-2 flex justify-center">
            <div className="relative w-full max-w-lg">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-piano-gold to-amber-400 rounded-lg blur opacity-30"></div>
              <div className="relative bg-white p-4 rounded-lg shadow-xl">
                <div className="aspect-[3/4] rounded-md overflow-hidden">
                  <img 
                    src="/lovable-uploads/c3099eea-1cdc-462a-9e3c-85f757436352.png" 
                    alt="Oscar Gilbert" 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
